import { createAppRequest } from '@/services/request';
import type {
  DictionaryGroup,
  DictionaryItemInput,
  DictionaryLabelRegistry,
  DictionaryResponse,
  DictionaryScope,
} from './types';

const request = createAppRequest();

export interface DictionaryUpdatePayload {
  items?: DictionaryItemInput[];
  /** 兼容旧调用：只传启用值列表 */
  values?: string[];
}

export const dictionaryApi = {
  getByScope: (scope: DictionaryScope) =>
    request<DictionaryResponse>(`/bff/dictionaries?scope=${scope}`),

  update: (
    scope: DictionaryScope,
    dictKey: string,
    payload: DictionaryUpdatePayload,
  ) =>
    request<DictionaryGroup>(`/bff/dictionaries/${dictKey}?scope=${scope}`, {
      method: 'PUT',
      data: payload,
    }),

  reset: (scope: DictionaryScope, dictKey: string) =>
    request<DictionaryGroup>(
      `/bff/dictionaries/${dictKey}/reset?scope=${scope}`,
      { method: 'POST' },
    ),

  labels: () =>
    request<DictionaryLabelRegistry>('/bff/dictionaries/labels', {
      skipErrorHandler: true,
    }),
};
